import { SIMILAR_STORES_VIEW } from './types';

export const triggerSimilarStoresIsViewed = (similarStores, merchantMatchName) => ({
  type: SIMILAR_STORES_VIEW,
  similarStores,
  merchantMatchName,
});
